import * as React from 'react';
import { Table } from "soprasteria-ui-library";
import { ICheckBudget } from "../../../models/ICheckBudget";

interface ICheckBudgetTable {
    checkBudgets: ICheckBudget[];
}

export const CheckBudgetTable: React.FunctionComponent<ICheckBudgetTable> = ({ checkBudgets }) => {

    return (
        <section>
            <Table>
                <thead>
                    <tr>
                        <th>Urvalsområde</th>
                        <th>År</th>
                        <th>Budget</th>
                        <th>Maximalt antal vårderbjudanden att besluta</th>
                        <th>Utfall</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        checkBudgets.length > 0
                            ? checkBudgets.map((checkBudget, key) => {
                                return (
                                    <tr key={key}>
                                        <td>{checkBudget.selectionAreaName}</td>
                                        <td>{checkBudget.year}</td>
                                        <td>{checkBudget.budget}</td>
                                        <td>{checkBudget.treatmentsToDecide}</td>
                                        <td>{checkBudget.outcome}</td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan={5}>Hittade inga vårderbjudanden att besluta</td></tr>
                    }
                </tbody>
            </Table>
        </section>
    )
}
